import api from './api';

const userService = {
  getProfile: () => api.get('/user/profile'),
  updateProfile: (data) => api.put('/user/profile', data, { skipAuthReplay: true }),
  // The Users directory opts into global role ordering and keeps name/email searches in a body.
  getUsers: (params) =>
    params?.sort === 'role'
      ? api.post('/admin/users/search', params)
      : api.get('/admin/users', { params }),
  getUserById: (id) => api.get(`/admin/users/${id}`),
  createUser: (data) => api.post('/admin/users', data),
  updateUser: (id, data) => api.put(`/admin/users/${id}`, data),
  // Phase 8: set a clinic login's practice role (owner|user). Server enforces clinic-users-only.
  setClinicRole: (id, clinicRole) => api.put(`/admin/users/${id}/clinic-role`, { clinicRole }),

  // REP ACCESS: per person, which accounts and which other reps they can see.
  /** Every sales rep with their accounts and their rep grants - unpaginated, admin only. */
  getRepAccess: () => api.get('/admin/users/rep-access'),
  /** Replace the FULL list of other reps this rep may see. [] revokes every grant. */
  setVisibleReps: (id, repIds) => api.put(`/admin/users/${id}/visible-reps`, { repIds }),
  /** The reps the caller may see. Rep-facing; the server reads it off the caller's own record. */
  getMyTeam: () => api.get('/user/my-team'),
};

export default userService;
